import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { Routes, Route, BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';


import reportWebVitals from './reportWebVitals';
import App11Page from './pages/app1/App11Page';
import SwapPage from './pages/app2/SwapPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/app1" element={<App11Page />}/>
      <Route path="/" element={<SwapPage />}/>
  </Routes>
  </BrowserRouter>
);

reportWebVitals();
